import { useEffect, useRef } from 'react';

// One request at a time; stop on unmount and while the browser tab is hidden.
export default function useChatPolling(callback, delay, enabled = true) {
  const current = useRef(callback);
  current.current = callback;
  useEffect(() => {
    if (!enabled) return undefined;
    const controller = new AbortController();
    let timer;
    let running = false;
    const tick = async () => {
      if (running || controller.signal.aborted) return;
      clearTimeout(timer);
      running = true;
      try {
        if (!document.hidden) await current.current(controller.signal);
      } finally {
        running = false;
        if (!controller.signal.aborted) timer = setTimeout(tick, delay);
      }
    };
    const visible = () => { if (!document.hidden) tick(); };
    tick();
    document.addEventListener('visibilitychange', visible);
    return () => {
      controller.abort();
      clearTimeout(timer);
      document.removeEventListener('visibilitychange', visible);
    };
  }, [delay, enabled]);
}
